import styled from 'styled-components';

import { mixins } from 'styles/mixins';

export const Subtitle = styled.div`
  ${mixins.text({ isHeading: true })}

  margin-bottom: 12px;
`;
